/*
  Close the mobile filter drawer when the shopper taps beside it.

  WHY DAWN'S OWN ATTEMPT DOES NOT WORK HERE

  Dawn covers the screen with a transparent pseudo-element on the summary:

      .disclosure-has-popup[open] > summary::before { position: fixed; inset: 0; z-index: 2 }

  Clicking it hits the summary, which toggles the <details> shut. But the
  drawer's own overlay, .mobile-facets, is z-index 100 with pointer-events:none
  — so a tap beside the panel passes THROUGH the overlay and lands on whatever
  the page has at that point, which is above z-index 2. The filter closed only
  by luck, and a product card underneath took the tap.

  So the overlay is given pointer-events back (in CSS, next to the rest of the
  drawer) and it becomes the thing that catches the tap. Nothing behind it can
  be reached any more, which is the real fix: an open drawer should make the
  page beneath it inert.

  CLOSING THROUGH THE SUMMARY, NOT BY REMOVING THE ATTRIBUTE

  summary.click() is the same route the X button and the "Apply" footer already
  take. <menu-drawer> owns the slide-out transition, the focus trap and the
  body scroll lock, and stripping `open` off the <details> by hand would leave
  all three behind — a page that cannot scroll and a focus trap with nothing to
  trap. Going through the summary lets it unwind its own state.
*/
(() => {
  document.addEventListener('click', (event) => {
    const overlay = event.target.closest('.mobile-facets');
    if (!overlay) return;

    // A tap on the panel itself is somebody using the filters.
    if (event.target.closest('.mobile-facets__inner')) return;

    const wrapper = overlay.closest('.mobile-facets__wrapper');
    if (!wrapper) return;

    const details = wrapper.querySelector('details.mobile-facets__disclosure');
    const summary = wrapper.querySelector('summary');
    if (!details || !summary || !details.hasAttribute('open')) return;

    // The overlay is a <form>; a stray submit is not wanted.
    event.preventDefault();
    summary.click();
  });
})();
